var _circle, _ellipse, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E9405B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.3232,
    cy: 12.3673,
    rx: 5.12142,
    ry: 5.12142,
    transform: "rotate(35.8002 11.3232 12.3673)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8281 7.17097C17.0209 3.76963 16.533 6.65128 19.0639 7.61873",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4926 6.38299L19.6619 7.24697L20.4929 6.95599L19.923 7.62708L20.6685 8.09532L19.7885 8.06817L19.8873 8.94304L19.3599 8.23809L18.7375 8.86079L18.9597 8.00889L18.0848 7.91052L18.8895 7.55316L18.4209 6.80779L19.202 7.21407L19.4926 6.38299Z",
    fill: "#FFB400"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8884,
    y: 6.51501,
    width: 2.12554,
    height: 1.06277,
    rx: 0.531385,
    transform: "rotate(34.0331 13.8884 6.51501)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreat);
export default __webpack_public_path__ + "static/media/threat.9b9d3d2f06facd5852ea2bb74a5ddbf4.svg";
export { ForwardRef as ReactComponent };